import {
    IEvent,
    IEventsBannerToWineTesting,
    IEventsFilterResponseItems,
    IEventsFilterResponseMeta,
    IEventsGroupedByDay,
} from 'modules/events/types';
import {createContext} from 'react';

interface IEventsListContext {
    canLoadMore: boolean;
    filter: IEventsFilterResponseItems;
    meta: IEventsFilterResponseMeta;
    events: IEvent[];
    eventsGroupedByDay: IEventsGroupedByDay[];
    loadMoreEvents?: () => void;
    isLoading: boolean;
    bannerToWineTesting?: IEventsBannerToWineTesting;
}

export const EventsListContext = createContext<IEventsListContext>({
    canLoadMore: false,
    filter: {},
    meta: {},
    events: [],
    eventsGroupedByDay: [],
    isLoading: false,
});
